import {
  Alert,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Snackbar,
  Typography
} from '@mui/material';
import { getObjectListByPropertyApi } from 'api/general';
import { sortByProperty } from 'app/utils/appHelpers';
import { MEETING_VIDEO } from 'app/utils/constants/customConstant';
import config from 'config';
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import MeetingTitleBox from '../Box/MeetingTitleBox';
import VideoListTable from '../Table/VideoListTable';

function VideoWatchDialog({ open, onClose, meeting }) {
  const [isFullScreen, setIsFullScreen] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(open);
  const [videoList, setVideoList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const getAPI = async () => {
      setLoading(true);
      try {
        const res = await getObjectListByPropertyApi(MEETING_VIDEO, "meetingId", meeting.id);
        let data = res.data;
        data = data.filter(x => x.type === 1 && x.status === 1)
        const sortedVideos = sortByProperty(data, "indexNo");
        setVideoList(sortedVideos);

        if (!data || data.length === 0) {
          Swal.fire({
            icon: "warning",
            title: "Video Bulunamadı",
            text: "Bu toplantıya ait herhangi bir video bulunmamaktadır!",
            confirmButtonText: "Tamam",
          });
          onClose();
          return;
        }

        setSelectedVideo(sortedVideos[0]);
        setDialogOpen(true);
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Hata!",
          text: "Video listesini getirirken hata oluştu.",
          confirmButtonText: "Tamam",
        });
        onClose();
      }
      setLoading(false);
    };

    if (open && meeting) {
      getAPI();
    }
  }, [open, meeting, onClose]);

  const toggleFullScreen = () => {
    setIsFullScreen((prev) => !prev);
  };

  return loading ? (
    <CircularProgress />
  ) : videoList && videoList.length > 0 ? (
    <Dialog
      onClose={onClose}
      open={dialogOpen}
      fullScreen={isFullScreen}
      // maxWidth={isFullScreen ? "xl" : "lg"}

      PaperProps={{
        sx: {
          width: isFullScreen ? '100%' : '1500px',
          maxWidth: isFullScreen ? '100%' : '1500px',
          backgroundColor: 'rgb(245,247,250)',
        },
      }}
    >
      <DialogTitle>
        <MeetingTitleBox
          meeting={meeting}
          toggleFullScreen={toggleFullScreen}
          onClose={onClose}
          isFullScreen={isFullScreen}
        />
      </DialogTitle>

      <DialogContent sx={{ overflow: "hidden" }}>


        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Card style={{ height: isFullScreen ? '890px' : '615px' }}>
              <CardContent>
                <VideoListTable
                  videos={videoList}
                  onVideoSelect={setSelectedVideo}
                  selectedVideo={selectedVideo}
                  isFullScreen={isFullScreen}
                />
              </CardContent>
            </Card>
          </Grid>



          <Grid item xs={9}>
            {selectedVideo ? (
              <Box sx={{ width: "100%", height: "70%", textAlign: "center" }}>
                <video
                  key={selectedVideo.filePath}
                  width="100%"
                  height="100%"
                  controls
                  autoPlay
                >
                  <source src={`${config.apiUrl}/uploads${selectedVideo.filePath}`} type="video/mp4" />
                  Tarayıcınız video etiketini desteklemiyor.
                </video>
              </Box>
            ) : (
              <Typography>Görüntülenecek video yok.</Typography>
            )}
          </Grid>



        </Grid>

        <Snackbar open={error} autoHideDuration={4000} onClose={() => setError(false)}>
          <Alert severity="error" onClose={() => setError(false)}>
            {message}
          </Alert>
        </Snackbar>
      </DialogContent>
    </Dialog>
  ) : null;
}

export default VideoWatchDialog;
